import React from 'react';
import { motion } from 'framer-motion';
import './CTA.css';

const APP_STORE_URL = 'https://apps.apple.com/us/app/trackable-io/id6755646710';

function CTA() {
  return (
    <section className="cta-section">
      <div className="container">
        <motion.div 
          className="cta-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.6 }}
        >
          <div className="cta-glow" />
          
          <div className="cta-content">
            <h2>Ready to meet your AI coach?</h2>
            <p>Experience fitness coaching that actually knows you. Download free on the App Store.</p>
            
            <motion.a 
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <svg className="apple-icon" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              Download on App Store
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </motion.a>
            
            <span className="cta-note">Free on iOS</span>
          </div>

          <div className="cta-visual">
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="screen-header">
                  <div className="screen-avatar" />
                  <span>AI Coach</span>
                </div>
                <div className="screen-messages">
                  <div className="screen-msg user">Let's crush today</div>
                  <div className="screen-msg ai">Ready when you are. I've got your workout queued up.</div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default CTA;
